export interface IPureSearchIndex {
    "@search.score": number;
    Uuid: string;
    Id: string;
    Model: IResearcher;
}

export interface IResearcher {
    Uuid: string;
    PureId: string;
    Name: string;
    KnownAs: string;
    ProfilePhoto: string;
    Info: IInfo[];
}

export interface IInfo {
    Language: Locale;
    DetailPageUrl: string;
    Prenominal: string;
    Postnominal: string;
    Summary: string;
    StaffOrganisationAssociations: IStaffOrganisationAssociation[];
}

export interface IStaffOrganisationAssociation {
    OrganisationalUnitNames: string[];
    JobTitle: string;
}

export enum Locale {
    EN = "en_GB",
    NL = "nl_NL"
}
